import { render } from "./NotifyBox.vue?vue&type=template&id=507268c0"
import script from "./NotifyBox.vue?vue&type=script&lang=js"
export * from "./NotifyBox.vue?vue&type=script&lang=js"

import "./NotifyBox.vue?vue&type=style&index=0&id=507268c0&lang=css"

import exportComponent from "/home/merlyn/Working/xiaorui.li/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__